import { action, observable } from 'mobx'
import { type IValidationSchema, required, validationContext } from 'validx'
import {
  QuestionEditorViewModelBase,
  type QuestionEditorViewModelOptions,
} from '@/features/legends/questions/QuestionEditorViewModelBase'
import type { BreakerQuestion } from '@/features/legends/questions/questions'

/**
 * Stops the client from continuing, with an explanation.
 */
export class BreakerQuestionEditorViewModel extends QuestionEditorViewModelBase<BreakerQuestion> {
  private readonly _schema: IValidationSchema<BreakerQuestionEditorViewModel> =
    {
      ...QuestionEditorViewModelBase.sharedSchema,
      question: [required('Title is required')],
    }

  readonly type = 'Breaker'

  /**
   * The breaker's title.
   */
  @observable accessor question = 'New Breaker'
  @observable accessor description = ''

  readonly validation = validationContext(this, this._schema)

  constructor(options: QuestionEditorViewModelOptions) {
    super(options)
    this._validateWhileEditing(this._schema)
  }

  /** @inheritDoc */
  get displayText() {
    return this.question
  }

  /** @inheritDoc */
  @action
  hydrate(question: BreakerQuestion) {
    this._hydrateShared(question)
    this.question = question.question ?? this.question
    this.description = question.description ?? ''
  }

  /** @inheritDoc */
  protected _serialize(): BreakerQuestion {
    return {
      ...this._serializeShared(),
      type: this.type,
      question: this.question,
      description: this.description,
    }
  }
}
